import { useEffect, useMemo, useSyncExternalStore } from 'react'
import { claimLegacyTemplates, createTemplateLibrary, TEMPLATE_LIBRARY_SCOPE } from '../lib/chart/serverIndicatorTemplates.js'
import { templateLibraryTransport } from '../lib/chart/templateLibraryTransport.js'

const stores = new Map()
const empty = { templates: [], status: 'loading' }
const disabled = { getSnapshot: () => empty, subscribe: () => () => {}, save: () => null }
export function useIndicatorTemplateLibrary(userId) {
  return useAccountTemplateLibrary(userId, TEMPLATE_LIBRARY_SCOPE, () => claimLegacyTemplates(userId))
}
export function useAccountTemplateLibrary(userId, scope, legacy) {
  const entry = useMemo(() => {
    if (!userId) return null
    const identity = JSON.stringify([userId, scope])
    if (!stores.has(identity)) {
      const key = `erevis-pending-template-edits-v1:${scope}:${userId}`
      stores.set(identity, {
        users: 0,
        store: createTemplateLibrary(templateLibraryTransport(userId, undefined, scope), {
          legacy,
          load: () => JSON.parse(localStorage.getItem(key) || '{}'),
          persist: value => Object.keys(value).length ? localStorage.setItem(key, JSON.stringify(value)) : localStorage.removeItem(key),
        }),
      })
    }
    return stores.get(identity)
    // Each source is fixed by its account/scope identity, not a render closure.
  }, [userId, scope])
  useEffect(() => {
    if (!entry) return
    if (++entry.users === 1) {
      entry.refresh = () => entry.store.refresh()
      entry.refresh()
      entry.timer = setInterval(() => { if (document.visibilityState !== 'hidden') entry.refresh() }, 3000)
      window.addEventListener('focus', entry.refresh)
      window.addEventListener('online', entry.refresh)
    }
    return () => {
      if (--entry.users === 0) {
        clearInterval(entry.timer)
        window.removeEventListener('focus', entry.refresh)
        window.removeEventListener('online', entry.refresh)
      }
    }
  }, [entry])
  const store = entry?.store || disabled
  const snapshot = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot)
  return { ...snapshot, save: store.save, retry: () => store.refresh?.() }
}
